import { tr } from 'date-fns/locale'
const { utcToZonedTime } = require('date-fns-tz')
const { isBefore, format } = require('date-fns')

export function dateFormat(date) {
    let d = new Date(date);
    return format(new Date(date), 'dd MMMM yyyy', { locale: tr });
}

export function isGreatThanNow(date) {
    return isBefore(new Date(), utcToZonedTime(new Date(date), 'Europe/Istanbul'))
}

export default { dateFormat, isGreatThanNow };
